module.exports = __webpack_public_path__ + "img/YE.b6569f11.svg";